import getLang from 'I18n/utils/getLang';
import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { Details as DetailsPage } from 'marketplace-ui-details/Details';
import { useUnifiedDetails } from 'marketplace-ui-details/hooks/useUnifiedDetails';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { NavMarker } from 'react-rhumb';
import { useParams } from 'react-router-dom';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { ProductPageHeader } from '../components/headers/ProductPageHeader';
import { Screens } from '../constants/usage';
import { useAppContext } from '../context/AppContext';
import { useAuth } from '../context/AuthContext';
// TODO: we should decide the actual props and what it will be used for
import { jsx as _jsx } from "react/jsx-runtime";
export function Details({
  __onTrackInteraction
}) {
  const {
    listingSlug
  } = useParams();
  const appContext = useAppContext();
  const auth = useAuth();
  const {
    unifiedDetailsData
  } = useUnifiedDetails({
    slug: listingSlug,
    language: getLang()
  });
  const {
    name
  } = unifiedDetailsData;
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "DETAILS_LOAD",
    children: /*#__PURE__*/_jsx(UsageScreenProvider, {
      screen: Screens.APPS,
      children: /*#__PURE__*/_jsx(DashboardPage, {
        headerComponent: /*#__PURE__*/_jsx(ProductPageHeader, {
          pathKey: "LISTING_DETAILS",
          title: name
        }),
        children: /*#__PURE__*/_jsx(ErrorBoundary, {
          children: /*#__PURE__*/_jsx(DetailsPage, {
            appContext: appContext,
            productType: "APP",
            published: true,
            slug: listingSlug,
            userInfo: auth
          })
        })
      })
    })
  });
}